export enum TypeCommunicationEnum {
  AllTypes = 1,
  Offline,
  Online
}
